var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContent1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 940,
    height: 326,
    viewBox: "0 0 940 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gr_3534",
    "data-name": "gr 3534",
    transform: "translate(-491 -925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gr_1452",
    "data-name": "gr 1452",
    transform: "translate(172.5 745)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uD788\\uC5B4\\uB85C_\\uB3CC\\uBD04\\uC11C\\uBE44\\uC2A4\\uB294_\\uC774\\uB807\\uAC8C_\\uC81C\\uACF5\\uB418\\uACE0_\\uC788\\uC5B4\\uC694",
    "data-name": "\\uD788\\uC5B4\\uB85C \\uB3CC\\uBD04\\uC11C\\uBE44\\uC2A4\\uB294  \\uC774\\uB807\\uAC8C \\uC81C\\uACF5\\uB418\\uACE0 \\uC788\\uC5B4\\uC694",
    transform: "translate(787.5 226)",
    fontSize: 40,
    fontFamily: "NotoSansCJKkr-Bold, Noto Sans CJK KR",
    fontWeight: 700,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -164.68,
    y: 0
  }, "\uD788\uC5B4\uB85C \uB3CC\uBD04\uC11C\uBE44\uC2A4\uB294 "), /*#__PURE__*/React.createElement("tspan", {
    x: -182.08,
    y: 55
  }, "\uC774\uB807\uAC8C \uC81C\uACF5\uB418\uACE0 \uC788\uC5B4\uC694"))), /*#__PURE__*/React.createElement("g", {
    id: "gr_3518",
    "data-name": "gr 3518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gr_1454",
    "data-name": "gr 1454",
    transform: "translate(-211.236 -906)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uC57C\\uC678\\uD65C\\uB3D9",
    transform: "translate(900.236 2103)",
    fill: "#484848",
    fontSize: 16,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC57C\uC678\uD65C\uB3D9"))), /*#__PURE__*/React.createElement("g", {
    id: "gr_1460",
    "data-name": "gr 1460",
    transform: "translate(688.572 1111.609)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "line_35",
    "data-name": "line 35",
    x2: 56,
    transform: "translate(0.428 50.39)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_36",
    "data-name": "line 36",
    y2: 29,
    transform: "translate(44.428 21.39)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_744",
    "data-name": "path 744",
    d: "M303.374,269.5l-2.937,2.937L297.5,269.5",
    transform: "translate(-256.166 -244.082)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_745",
    "data-name": "path 745",
    d: "M304.159,279l-4.615,4.615L294.929,279",
    transform: "translate(-255.273 -247.382)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_37",
    "data-name": "line 37",
    y2: 18,
    transform: "translate(22.428 32.39)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_746",
    "data-name": "path 746",
    d: "M270.526,285l-3.263,3.263L264,285",
    transform: "translate(-244.529 -249.466)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_747",
    "data-name": "path 747",
    d: "M305.871,270.622l-1.207-15.1h-.033a7.176,7.176,0,0,0-14.293,0h-.033l-1.207,15.1a8.485,8.485,0,1,0,16.773,0Z",
    transform: "translate(-253.213 -236.961)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_20",
    "data-name": "ellipse 20",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(15.428 28.39)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_21",
    "data-name": "ellipse 21",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(8.428 6.39)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_38",
    "data-name": "line 38",
    y2: 3,
    transform: "translate(12.428 17.39)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_39",
    "data-name": "line 39",
    x2: 2.307,
    y2: 2.307,
    transform: "translate(17.368 15.81)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_40",
    "data-name": "line 40",
    x2: 3,
    transform: "translate(19.428 10.39)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_41",
    "data-name": "line 41",
    y1: 2.307,
    x2: 2.307,
    transform: "translate(17.368 3.35)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_42",
    "data-name": "line 42",
    y1: 3,
    transform: "translate(12.428 0.39)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_43",
    "data-name": "line 43",
    x1: 2.307,
    y1: 2.307,
    transform: "translate(4.908 3.35)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_44",
    "data-name": "line 44",
    x1: 3,
    transform: "translate(1.428 10.39)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_45",
    "data-name": "line 45",
    x1: 2.307,
    y2: 2.307,
    transform: "translate(4.908 15.81)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "gr_1453",
    "data-name": "gr 1453",
    transform: "translate(-367.236 -906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_45_1",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 45 \\u2013 1",
    transform: "translate(872.236 2084)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uB4F1\\uD558\\uC6D0_\\uB4F1\\uD558\\uAD50",
    "data-name": "\\uB4F1\\uD558\\uC6D0/\\uB4F1\\uD558\\uAD50",
    transform: "translate(0 19)",
    fill: "#484848",
    fontSize: 16,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uB4F1\uD558\uC6D0/\uB4F1\uD558\uAD50")))), /*#__PURE__*/React.createElement("g", {
    id: "gr_1461",
    "data-name": "gr 1461",
    transform: "translate(529 1114.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_748",
    "data-name": "path 748",
    d: "M137.062,287.108a3.165,3.165,0,0,0-.523,4.446h0a3.165,3.165,0,0,0,4.445.522s8.792-6.436,14.37-11.347A49.557,49.557,0,0,0,164.667,269",
    transform: "translate(-119.117 -249.078)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_749",
    "data-name": "path 749",
    d: "M142.82,285.641l-12.074,9.427a3.166,3.166,0,0,1-4.446-.523h0a3.165,3.165,0,0,1,.523-4.445",
    transform: "translate(-115.56 -254.859)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_750",
    "data-name": "path 750",
    d: "M136.248,275.319l-13.205,10.427a3.165,3.165,0,0,1-4.445-.522h0a3.165,3.165,0,0,1,.523-4.445l12.891-10.18",
    transform: "translate(-112.885 -249.634)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_751",
    "data-name": "path 751",
    d: "M122.952,274.938a3.164,3.164,0,0,1-4.445-.522h0a3.164,3.164,0,0,1,.522-4.445l9.375-7.4",
    transform: "translate(-112.853 -246.844)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_752",
    "data-name": "path 752",
    d: "M125.676,243.844l.972.346a2.288,2.288,0,0,0,2.336-.506,2.763,2.763,0,0,1,2.822-.592l4.329,1.54,6.066,2.158,9.339,3.323a.2.2,0,0,1,.125.261l-.1.271a5.026,5.026,0,0,1-6.421,3.05l-4.8-1.708a.2.2,0,0,0-.235.083,8.066,8.066,0,0,1-9.516,3.281,12.132,12.132,0,0,1-3.393-1.795",
    transform: "translate(-115.58 -240.023)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect_1379",
    "data-name": "rect 1379",
    width: 5.519,
    height: 14.611,
    transform: "translate(4.898 1.968) rotate(19.586)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_753",
    "data-name": "path 753",
    d: "M118,265a5.025,5.025,0,0,0,3.826,3.654",
    transform: "translate(-112.914 -247.689)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_754",
    "data-name": "path 754",
    d: "M158.484,246.761a12.778,12.778,0,0,0-8.484.653",
    transform: "translate(-124.029 -241.197)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect_1378",
    "data-name": "rect 1378",
    width: 7.21,
    height: 19.977,
    transform: "matrix(0.785, -0.62, 0.62, 0.785, 33.668, 4.468)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "gr_1455",
    "data-name": "gr 1455",
    transform: "translate(-50.236 -906)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uC2DD\\uC0AC\\uC9C0\\uB3C4",
    transform: "translate(900.236 2103)",
    fill: "#484848",
    fontSize: 16,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC2DD\uC0AC\uC9C0\uB3C4"))), /*#__PURE__*/React.createElement("g", {
    id: "gr_1462",
    "data-name": "gr 1462",
    transform: "translate(850 1118.809)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse_22",
    "data-name": "ellipse 22",
    cx: 9.794,
    cy: 9.794,
    rx: 9.794,
    ry: 9.794,
    transform: "translate(17.859 6.337)",
    fill: "none",
    stroke: "#f69f30",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse_23",
    "data-name": "ellipse 23",
    cx: 16.131,
    cy: 16.131,
    rx: 16.131,
    ry: 16.131,
    transform: "translate(11.522 0)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_755",
    "data-name": "path 755",
    d: "M369.885,255.313a4.609,4.609,0,0,1-9.218,0c0-2.545,2.063-6.913,4.609-6.913S369.885,252.768,369.885,255.313Z",
    transform: "translate(-360.667 -248.4)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_46",
    "data-name": "line 46",
    y2: 9.218,
    transform: "translate(4.609 10.946)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect_1380",
    "data-name": "rect 1380",
    width: 3.457,
    height: 16.046,
    rx: 1.728,
    transform: "translate(2.88 19.588)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_47",
    "data-name": "line 47",
    y2: 17.86,
    transform: "translate(50.794 1.728)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect_1381",
    "data-name": "rect 1381",
    width: 3.457,
    height: 16.046,
    rx: 1.728,
    transform: "translate(49.066 19.588)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_756",
    "data-name": "path 756",
    d: "M440.787,251.048v5.626a4.9,4.9,0,0,1-4.9,4.9h0a4.9,4.9,0,0,1-4.9-4.9v-5.626",
    transform: "translate(-385.096 -249.32)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "gr_1456",
    "data-name": "gr 1456",
    transform: "translate(111.764 -906)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uBAA9\\uC695\\uC9C0\\uB3C4",
    transform: "translate(900.236 2103)",
    fill: "#484848",
    fontSize: 16,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uBAA9\uC695\uC9C0\uB3C4"))), /*#__PURE__*/React.createElement("g", {
    id: "gr_1463",
    "data-name": "gr 1463",
    transform: "translate(1014 1114.809)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect_1382",
    "data-name": "rect 1382",
    width: 52.211,
    height: 4.061,
    rx: 2.03,
    transform: "translate(0 14.938)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect_1383",
    "data-name": "rect 1383",
    d: "M0,0H46.41a0,0,0,0,1,0,0V5.917A15.547,15.547,0,0,1,30.863,21.464h-9.4A21.464,21.464,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(2.32 18.999)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_48",
    "data-name": "line 48",
    x1: 1.595,
    y2: 4.496,
    transform: "translate(15.373 39.738)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_49",
    "data-name": "line 49",
    x2: 1.437,
    y2: 3.771,
    transform: "translate(37.418 40.463)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_757",
    "data-name": "path 757",
    d: "M551.111,240.9v-.437a4.351,4.351,0,0,1,4.351-4.351h0a4.351,4.351,0,0,1,4.35,4.351v10.877",
    transform: "translate(-512.533 -236.111)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect_1384",
    "data-name": "rect 1384",
    d: "M3.481,0h1.74A3.481,3.481,0,0,1,8.7,3.481v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A3.481,3.481,0,0,1,3.481,0Z",
    transform: "translate(34.227 4.931)",
    fill: "none",
    stroke: "#f69f30",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "gr_1457",
    "data-name": "gr 1457",
    transform: "translate(195.764 -918)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uCC45\\uC77D\\uAE30_\\uBC0F_\\uC219\\uC81C\\uC9C0\\uB3C4_\\uC628\\uB77C\\uC778_\\uD559\\uC2B5_\\uC9C0\\uB3C4_",
    "data-name": "\\uCC45\\uC77D\\uAE30 \\uBC0F \\uC219\\uC81C\\uC9C0\\uB3C4  (\\uC628\\uB77C\\uC778 \\uD559\\uC2B5 \\uC9C0\\uB3C4)",
    transform: "translate(1005.236 2106)",
    fill: "#484848",
    fontSize: 16,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -60.28,
    y: 0
  }, "\uCC45\uC77D\uAE30 \uBC0F \uC219\uC81C\uC9C0\uB3C4 "), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 12
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -42.6,
    y: 18
  }, "(\uC628\uB77C\uC778 \uD559\uC2B5 \uC9C0\uB3C4)")))), /*#__PURE__*/React.createElement("g", {
    id: "gr_1489",
    "data-name": "gr 1489",
    transform: "translate(355.764 -907)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uD788\\uC5B4\\uB85C_\\uB180\\uC774",
    "data-name": "\\uD788\\uC5B4\\uB85C \\uB180\\uC774",
    transform: "translate(1005.236 2104)",
    fill: "#484848",
    fontSize: 16,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.6,
    y: 0
  }, "\uD788\uC5B4\uB85C \uB180\uC774"))), /*#__PURE__*/React.createElement("g", {
    id: "gr_1481",
    "data-name": "gr 1481",
    transform: "translate(557 878.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gr_1479",
    "data-name": "gr 1479",
    transform: "translate(628 235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_763",
    "data-name": "path 763",
    d: "M628,235v46.061h36.578V246.383L653.313,235Z",
    transform: "translate(-628 -235)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_764",
    "data-name": "path 764",
    d: "M664.479,236v10.852h11.854",
    transform: "translate(-11.769 -0.323)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_55",
    "data-name": "line 55",
    x2: 20.335,
    transform: "translate(635.437 256.013)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_56",
    "data-name": "line 56",
    x2: 12.884,
    transform: "translate(635.437 261.657)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_57",
    "data-name": "line 57",
    x2: 12.884,
    transform: "translate(635.437 267.302)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_58",
    "data-name": "line 58",
    x2: 14.916,
    transform: "translate(635.437 272.947)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "gr_1480",
    "data-name": "gr 1480",
    transform: "translate(650.431 245.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_765",
    "data-name": "path 765",
    d: "M667.581,277.07l-6.466,1.2,1.2-6.466,21.075-21.075,5.269,5.269Z",
    transform: "translate(-661.115 -250.726)",
    fill: "#fff",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_59",
    "data-name": "line 59",
    x2: 5.269,
    y2: 5.269,
    transform: "translate(18.785 3.487)",
    fill: "#fff",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gr_1490",
    "data-name": "gr 1490",
    transform: "translate(711.492 726.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_782",
    "data-name": "path 782",
    d: "M678.633,410.471l-27.04,22.978-27.04-22.978,8.683-12.726H669.95Z",
    transform: "translate(-1.637 -1.173)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_783",
    "data-name": "path 783",
    d: "M682.4,410.115l-32.448,27.573-32.448-27.573,11.955-17.421H670.45Z",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_65",
    "data-name": "line 65",
    y2: 13.818,
    transform: "translate(642.451 403.676)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_66",
    "data-name": "line 66",
    y2: 13.818,
    transform: "translate(656.269 403.676)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "line_67",
    "data-name": "line 67",
    x2: 13.826,
    transform: "translate(642.443 410.476)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uC548\\uC804\\uD55C_\\uB4F1\\uD558\\uAD50\\uAE38_\\uC2E4\\uC2DC\\uAC04\\uC73C\\uB85C_\\uBCF4\\uACE0\\uD574\\uC694",
    "data-name": "\\uC548\\uC804\\uD55C \\uB4F1\\uD558\\uAD50\\uAE38  \\uC2E4\\uC2DC\\uAC04\\uC73C\\uB85C \\uBCF4\\uACE0\\uD574\\uC694",
    transform: "translate(551 1227)",
    fill: "#484848",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR DemiLight",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -46.762,
    y: 0
  }, "\uC548\uC804\uD55C \uB4F1\uD558\uAD50\uAE38 "), /*#__PURE__*/React.createElement("tspan", {
    x: -59.521,
    y: 20
  }, "\uC2E4\uC2DC\uAC04\uC73C\uB85C \uBCF4\uACE0\uD574\uC694")), /*#__PURE__*/React.createElement("text", {
    id: "\\uB118\\uCE58\\uB294_\\uC5D0\\uB108\\uC9C0_\\uBC16\\uC5D0\\uC11C_\\uD568\\uAED8_\\uD480\\uC5B4\\uC694",
    "data-name": "\\uB118\\uCE58\\uB294 \\uC5D0\\uB108\\uC9C0 \\uBC16\\uC5D0\\uC11C \\uD568\\uAED8 \\uD480\\uC5B4\\uC694",
    transform: "translate(717 1227)",
    fill: "#484848",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR DemiLight",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -40.201,
    y: 0
  }, "\uB118\uCE58\uB294 \uC5D0\uB108\uC9C0"), /*#__PURE__*/React.createElement("tspan", {
    x: -54.642,
    y: 20
  }, "\uBC16\uC5D0\uC11C \uD568\uAED8 \uD480\uC5B4\uC694")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC900\\uBE44\\uD574\\uC8FC\\uC2E0_\\uC2DD\\uC0AC_\\uB530\\uB73B\\uD558\\uAC8C_\\uC9C0\\uB3C4\\uD574\\uC694",
    "data-name": "\\uC900\\uBE44\\uD574\\uC8FC\\uC2E0 \\uC2DD\\uC0AC \\uB530\\uB73B\\uD558\\uAC8C \\uC9C0\\uB3C4\\uD574\\uC694",
    transform: "translate(880 1227)",
    fill: "#484848",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR DemiLight",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -46.641,
    y: 0
  }, "\uC900\uBE44\uD574\uC8FC\uC2E0 \uC2DD\uC0AC"), /*#__PURE__*/React.createElement("tspan", {
    x: -53.081,
    y: 20
  }, "\uB530\uB73B\uD558\uAC8C \uC9C0\uB3C4\uD574\uC694")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC57C\\uC678\\uD65C\\uB3D9_\\uD6C4_\\uC190\\uBC1C\\uC744_\\uAE68\\uB057\\uC774_\\uD574\\uC694",
    "data-name": "\\uC57C\\uC678\\uD65C\\uB3D9 \\uD6C4 \\uC190\\uBC1C\\uC744 \\uAE68\\uB057\\uC774 \\uD574\\uC694",
    transform: "translate(1039 1227)",
    fill: "#484848",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR DemiLight",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.761,
    y: 0
  }, "\uC57C\uC678\uD65C\uB3D9 \uD6C4"), /*#__PURE__*/React.createElement("tspan", {
    x: -54.642,
    y: 20
  }, "\uC190\uBC1C\uC744 \uAE68\uB057\uC774 \uD574\uC694")), /*#__PURE__*/React.createElement("text", {
    id: "\\uCC45\\uC77D\\uB294_\\uC2DC\\uAC04_\\uC2B5\\uAD00\\uC73C\\uB85C_\\uB9CC\\uB4E4\\uC5B4\\uC694",
    "data-name": "\\uCC45\\uC77D\\uB294 \\uC2DC\\uAC04, \\uC2B5\\uAD00\\uC73C\\uB85C \\uB9CC\\uB4E4\\uC5B4\\uC694",
    transform: "translate(1201 1227)",
    fill: "#484848",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR DemiLight",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -35.651,
    y: 0
  }, "\uCC45\uC77D\uB294 \uC2DC\uAC04,"), /*#__PURE__*/React.createElement("tspan", {
    x: -53.081,
    y: 20
  }, "\uC2B5\uAD00\uC73C\uB85C \uB9CC\uB4E4\uC5B4\uC694")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC5F0\\uB839\\uBCC4_\\uB9DE\\uCDA4\\uB180\\uC774\\uB85C_\\uC990\\uAC70\\uC6B4_\\uC2DC\\uAC04\\uC744_\\uBCF4\\uB0B4\\uC694",
    "data-name": "\\uC5F0\\uB839\\uBCC4 \\uB9DE\\uCDA4\\uB180\\uC774\\uB85C \\uC990\\uAC70\\uC6B4 \\uC2DC\\uAC04\\uC744 \\uBCF4\\uB0B4\\uC694",
    transform: "translate(1369 1227)",
    fill: "#484848",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR DemiLight",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -53.081,
    y: 0
  }, "\uC5F0\uB839\uBCC4 \uB9DE\uCDA4\uB180\uC774\uB85C"), /*#__PURE__*/React.createElement("tspan", {
    x: -61.082,
    y: 20
  }, "\uC990\uAC70\uC6B4 \uC2DC\uAC04\uC744 \uBCF4\uB0B4\uC694"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent1);
export default __webpack_public_path__ + "static/media/content1.0f129f54.svg";
export { ForwardRef as ReactComponent };